import InformationSmallBanner from "../../components/InformationSmallBanner/InformationSmallBanner";
import { LeagueFormatter } from "../../components/LeagueFormatter/LeagueFormatter";
import PersianDate from "../../components/PersianDate/PersianDate";

const DetailsUser = ({ detailsUsers }) => {
  return (
    <div className="card mt-3">
      <div className="row">
        <div className="col-xl-2 col-6 my-2 ">
          <InformationSmallBanner
            title={" تعداد سکه کاربر "}
            value={Number(detailsUsers?.balance) || 0}
            background="linear-gradient(135deg, #4e8eff 0%, #1b67c4 50%, #194daf 100%)"
          />
        </div>
        <div className="col-xl-2 col-6 my-2 ">
          <InformationSmallBanner
            title="تعداد نصب"
            value={detailsUsers?.installaitionCount || 0}
            background="linear-gradient(135deg, #4e8eff 0%, #1b67c4 50%, #194daf 100%)"
          />
        </div>
        <div className="col-xl-2 col-6 my-2 ">
          <InformationSmallBanner
            title={" موقعیت مکانی"}
            value={
              `${detailsUsers?.provinceName} - ${detailsUsers?.userCityName}` ||
              "_"
            }
            background="linear-gradient(135deg, #4e8eff 0%, #1b67c4 50%, #194daf 100%)"
          />
        </div>
        <div className="col-xl-2 col-6 my-2 ">
          <InformationSmallBanner
            title={"لیگ"}
            value={LeagueFormatter(detailsUsers?.league) || "—"}
            background="linear-gradient(135deg, #4e8eff 0%, #1b67c4 50%, #194daf 100%)"
          />
        </div>
        <div className="col-xl-2 col-6 my-2 ">
          <InformationSmallBanner
            title={" تاریخ ثبت نام در اپ "}
            value={<PersianDate date={detailsUsers?.registerTime} />}
            background="linear-gradient(135deg, #4e8eff 0%, #1b67c4 50%, #194daf 100%)"
          />
        </div>
        <div className="col-xl-2 col-6 my-2 ">
          <InformationSmallBanner
            title={" تابلو‌ای که بیشتر نصب کرده "}
            value={detailsUsers?.mustInstalledName || "-"}
            background="linear-gradient(135deg, #4e8eff 0%, #1b67c4 50%, #194daf 100%)"
          />
        </div>
      </div>
    </div>
  );
};
export default DetailsUser;
